let observer2;

function initSwipeListener() {
  if (window.innerWidth <= 1023) {
    if (!observer2) {
      observer2 = new MutationObserver((mutationsList) => {
        const panel = document.querySelector(".slide-panel-container");
        if (panel && !panel.dataset.swipeAdded) {
          panel.dataset.swipeAdded = "true";
          let startX = 0;
          let endX = 0;
          const threshold = 50;
          panel.addEventListener("touchstart", function (e) {
            if(e.target.tagName == "IMG"){
              e.preventDefault();
            }else{
              startX = e.touches[0].clientX;
            }
          });
          panel.addEventListener("touchend", function (e) {
            if(e.target.tagName == "IMG"){
              e.preventDefault();
            }else{
              endX = e.changedTouches[0].clientX;
              if (endX - startX > threshold) {
                let closeBtn = document.querySelector(`[data-testid="slide-panel-close-button"]`);
                if (closeBtn) closeBtn.click();
              }
            }
          });
        }
      });

      observer2.observe(document.body, { childList: true, subtree: true });
    }
  } else {
    if (observer2) {
      observer2.disconnect();
      observer2 = null;
    }
  }
}

initSwipeListener();

window.addEventListener("resize", initSwipeListener);

document.addEventListener('DOMContentLoaded', function () {
  const tryInjectCSS = () => {
    const formEmbed = document.querySelector('form-embed');

    if (formEmbed && formEmbed.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        #app-embed ._inline_stahb_47 {
          padding: 3.6rem 0;
        }

        #app-embed ._gridItemContent_stahb_257 {
          padding: 0;
        }

        #app-embed section._formHeader_1nihh_19 {
          margin: 0 0 2.8rem;
        }

        #app-embed h2._textHeading_2aowh_35 {
          font-size: 3rem;
          font-weight: 500;
          line-height: 1.17;
          margin-bottom: 2rem;
          font-family: 'NeueKabel';
        }

        #app-embed h2._textHeading_2aowh_35 {
          font-size: 3rem;
          font-weight: 500;
          line-height: 1.17;
          margin-bottom: 2rem;
          font-family: 'NeueKabel';
        }

        #app-embed ._textBody_2aowh_10 {
          max-width: 100%;
          margin: 0 auto;
          font-family: 'NeueKabel';
          font-weight: normal;
          font-size: 1.6rem;
          line-height: 1.6;
        }

        #app-embed ._inline_stahb_47 ._formContainer_stahb_30 {
          position: relative;
          width: 100%;
          max-width: calc(100% - 4rem);
          margin: 0 auto;
        }

        #app-embed form._formFieldset_1nihh_63 {
          gap: 0;
          padding: 0;
        }

        #app-embed input._formInputField_237zm_7,
        #app-embed input._formPhoneInputField_1ym3p_17,
        #app-embed ._textArea_17mgw_1 {
          font-family: 'NeueKabel';
          font-weight: normal;
          font-size: 1.6rem;
          line-height: 1.6;
          box-sizing: border-box;
        }

        #app-embed ._selectContainer_1yit2_6 {
          position: static;
        }

        #app-embed ._selectToggle_1yit2_25 {
          align-items: center;
        }

        #app-embed ._formPhoneInputContainer_1ym3p_6 {
          grid-template-columns: minmax(0, 0.6fr) minmax(0, 2.4fr);
          align-items: flex-end;
          padding-top: 2.7rem;
          margin-top: 2.5rem;
        }

        #app-embed ._formPhoneInputContainer_1ym3p_6 label._formInputFieldLabel_1ydxd_37 {
          position: absolute;
          top: 0 !important;
          left: 0;
        }

        #app-embed ._formPhoneInputContainer_1ym3p_6 ._formFieldContainer_1ydxd_5 {
          margin-top: 0;
        }

        #app-embed button._formSubmitButton_1nihh_77 {
          width: 20rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-top: 2.5rem;
          font-family: 'NeueKabel';
          font-size: 1.1rem;
          line-height: 1.3;
          letter-spacing: 0.1rem;
          font-weight: 700;
          height: 3.5rem;
          padding: 0 2rem;
          text-align: center;
          text-transform: uppercase;
          border-radius: 0.8rem;
          box-sizing: border-box;
        }

        #app-embed ._formError_1ydxd_20 {
          margin-top: 0.4rem;
          font-family: 'NeueKabel';
          font-size: 1.5rem;
          line-height: 1.3;
        }

        #app-embed button._formSubmitButton_1nihh_77:focus-visible,
        #app-embed button._formSubmitButton_1nihh_77:hover {
          color: #ffffff;
          background-color: #29861b;
          filter: none;
        }

        #app-embed ._selectToggle_1yit2_25,
        #app-embed input._formPhoneInputField_1ym3p_17,
        #app-embed input._formInputField_237zm_7 {
          height: 4rem;
          padding: 0 2rem;
          border: 1px solid #747474;
          border-radius: 0.8rem;
          letter-spacing: inherit;
          box-shadow: none;
        }

        #app-embed ._selectToggle_1yit2_25 {
          padding: 0 1rem 0 1.5rem;
        }

        #app-embed ._dropdownContainer_1yit2_60 {
          width: calc(100% - 0.2rem);
          padding: 0;
          border: 1px solid #747474;
          border-radius: 0.8rem;
        }

        #app-embed ._textArea_17mgw_1 {
          height: 7.8rem;
          padding: 1.5rem;
          border: 1px solid #747474;
          border-radius: 0.8rem;
          box-shadow: none;
        }

        #app-embed ._optionListItem_1yit2_99 > div {
          font-family: 'NeueKabel';
          font-weight: normal;
          font-size: 1.6rem;
          line-height: 1.6;
        }

        #app-embed ._optionListItemSelected_1yit2_109 > div,
        #app-embed ._optionListItem_1yit2_99 > div:focus,
        #app-embed ._optionListItem_1yit2_99:hover {
          background-color: transparent;
          outline: 0.1rem solid #3dae2b;
        }

        #app-embed input._formInputField_237zm_7:focus,
        #app-embed input._formPhoneInputField_1ym3p_17:focus,
        #app-embed ._textArea_17mgw_1:focus {
          border-color: #3dae2b;
        }

        #app-embed ._optionListItemSelected_1yit2_109 {
          box-shadow: none;
        }

        #app-embed input._formInputField_237zm_7:focus-visible,
        #app-embed input._formPhoneInputField_1ym3p_17:focus-visible,
        #app-embed ._textArea_17mgw_1:focus-visible {
          box-shadow: none;
        }

        #app-embed label._formInputFieldLabel_1ydxd_37 {
          position: static;
          font-family: 'NeueKabel';
          font-size: 1.2rem;
          line-height: 1.3;
          font-weight: 400;
          color: var(--form-text-color);
          transform: none !important;
        }

        #app-embed div._formFieldContainer_1ydxd_5 {
          position: static;
          flex-direction: column-reverse;
          gap: 1rem;
          margin-top: 2.5rem;
        }

        #app-embed div._formFieldContainer_1ydxd_5:first-child {
          margin-top: 0;
        }

        @media (min-width: 768px) {
          #app-embed section._formHeader_1nihh_19 {
            margin-bottom: 4.9rem;
          }

          #app-embed ._inline_stahb_47 ._formContainer_stahb_30 {
            max-width: 50rem;
          }

          #app-embed ._formPhoneInputContainer_1ym3p_6 {
            grid-template-columns: minmax(0, 0.5fr) minmax(0, 2.5fr);
          }
        }

        @media (min-width: 1024px) {
          #app-embed ._inline_stahb_47 {
            padding: 8rem 0;
          }

          #app-embed h2._textHeading_2aowh_35 {
            font-size: 4.5rem;
            line-height: 1.07;
          }

          #app-embed ._textBody_2aowh_10 {
            max-width: 40rem;
            font-size: 1.8rem;
            line-height: 1.7;
          }

          #app-embed input._formInputField_237zm_7,
          #app-embed ._textArea_17mgw_1 {
            font-size: 1.8rem;
            line-height: 1.7;
          }

          #app-embed label._formInputFieldLabel_1ydxd_37 {
            font-size: 1.3rem;
          }

          #app-embed button._formSubmitButton_1nihh_77 {
            height: 4rem;
            font-size: 1.3rem;
          }
        }

        @media (min-width: 1440px) {
          #app-embed label._formInputFieldLabel_1ydxd_37 {
            font-size: 1.5rem;
          }
        }
      `;
      formEmbed.shadowRoot.appendChild(style);
    } else {
      setTimeout(tryInjectCSS, 300);
    }
  };

  tryInjectCSS();
});


let subscriptionData = {};
try {
  const dataElement = document.getElementById('subscription-data');
  if (!dataElement) throw new Error("Missing element with ID 'subscription-data'");
  subscriptionData = JSON.parse(dataElement.textContent);
} catch (error) {
  console.error("Failed to parse subscription data:", error);
}

function getSelectedVariantIdFromOptions() {
  try {
    const options = Array.from(document.querySelectorAll('.product-form__variants input[type="radio"]:checked'))
      .map(input => input.value);

    return Object.keys(subscriptionData).find(variantId => {
      const variant = subscriptionData[variantId];
      if (!variant || !variant.options) return false;
      return JSON.stringify(variant.options) === JSON.stringify(options);
    });
  } catch (error) {
    console.error("Error getting selected variant ID:", error);
    return null;
  }
}

function updateDiscountDisplay(variantId) {
  try {
    const data = subscriptionData[variantId];
    if (data) {
      const discountEl = document.querySelector('.subscription_discount--price');
      if (discountEl) {
        let valueToDisplay = data.discount !== undefined && data.discount !== null
          ? data.discount
          : data.price;

        discountEl.textContent = valueToDisplay;
      } else {
        console.warn("Discount display element not found.");
      }
    } else {
      console.warn(`No subscription data found for variant ID: ${variantId}`);
    }
  } catch (error) {
    console.error("Error updating discount display:", error);
  }
}

document.addEventListener('change', function (e) {
  try {
    if (e.target.matches('.product-form__variants input[type="radio"]')) {
      const selectedVariantId = getSelectedVariantIdFromOptions();
      console.log('selectedVariantId', selectedVariantId);
      if (selectedVariantId) {
        updateDiscountDisplay(selectedVariantId);
      }
    }
  } catch (error) {
    console.error("Error handling change event:", error);
  }
});



document.addEventListener('DOMContentLoaded', function () {
  
  function updateActivePurchaseOption() {
    const onetimeRadio = document.querySelector('input[name="purchase_type"][value="onetime"]');
    const autodeliverRadio = document.querySelector('input[name="purchase_type"][value="autodeliver"]');
    const oneTimeWrapper = document.querySelector('.one-time__wrapper');
    const subscribeWrapper = document.querySelector('.subscribe-save__wrapper');

    oneTimeWrapper.classList.add('active');


    if (oneTimeWrapper && subscribeWrapper) {

      oneTimeWrapper.classList.remove('active');
      subscribeWrapper.classList.remove('active');
      if (onetimeRadio?.checked) {
        oneTimeWrapper.classList.add('active');
      } else if (autodeliverRadio?.checked) {
        subscribeWrapper.classList.add('active');
      }
    }
  }
  // Initial check on page load

  // Change handler for purchase_type radio buttons
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="purchase_type"]')) {
      updateActivePurchaseOption();
    }
  });

  setTimeout(() => {
    updateActivePurchaseOption();
  }, 1000);
});



document.addEventListener("DOMContentLoaded", function () {
  const firstSubcategory = document.querySelector(".subcategorie");
  const bannerTemplate = document.querySelector("#subscription-banner-template");

  if (firstSubcategory && bannerTemplate) {
    const productList = firstSubcategory.querySelector(".subcategorie__list");
    const items = productList?.querySelectorAll(".product-card-wrapper");

    if (productList && items.length >= 3) {
      const bannerClone = bannerTemplate.content.cloneNode(true);
      // Insert after the 3rd item (index 2)
      items[2].after(bannerClone);
    }
  }
});
